import React, { useState, useEffect } from "react";
import { Segmented } from "antd";
import RecentChatList from "./RecentChatList";
import ContactList from "./ContactList";
import styles from "./ChatSidebar.module.scss";
import { useSearchParamsV6 } from "../../hooks/useSearchParamsV6";

type TabType = "recent" | "contacts";

const ChatSidebar: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>("recent");
  const [searchParams] = useSearchParamsV6();

  // Switch to recent tab when a contact is clicked (id and t params are set)
  useEffect(() => {
    const id = searchParams.get("id");
    const t = searchParams.get("t");

    if (id && t === "contact") {
      setActiveTab("recent");
    }
  }, [searchParams]);

  return (
    <div className={styles.chatSidebar}>
      {/* Tabs */}
      <div className={styles.tabsContainer}>
        <Segmented
          value={activeTab}
          onChange={(value) => setActiveTab(value as TabType)}
          options={[
            { label: "Trò chuyện", value: "recent" },
            { label: "Danh bạ", value: "contacts" },
          ]}
          block
          className={styles.segmented}
        />
      </div>

      {/* Content */}
      <div className={styles.content}>{activeTab === "recent" ? <RecentChatList /> : <ContactList />}</div>
    </div>
  );
};

export default ChatSidebar;
